var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.739,
    height: 11.15,
    viewBox: "0 0 7.739 11.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:none;stroke:#2d527c;stroke-linecap:round;stroke-linejoin:round;stroke-width:.8px}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "np_edit_882832_030303",
    transform: "translate(0.405 0.429)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_362",
    d: "M32.534 29.664L30.3 30.977l.151-2.587 4.674-7.651a.177.177 0 0 1 .242-.058l1.783 1.09a.176.176 0 0 1 .058.242z",
    className: "cls-1",
    transform: "translate(-30.301 -20.656)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_363",
    d: "M53.5 28.059l2.082 1.274",
    className: "cls-1",
    transform: "translate(-49.421 -26.757)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_364",
    d: "M31.129 64.641l2.082 1.273",
    className: "cls-1",
    transform: "translate(-30.984 -56.906)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPen);
export default __webpack_public_path__ + "static/media/edit_pen.ff465bb7.svg";
export { ForwardRef as ReactComponent };